<template>
  <div class="head" ref="head">
    <div class="leftcont">
      <span class="name">{{info.companyName}}</span>
      <el-popover
        placement="top-start"
        class="workbar"
        height="100"
        trigger="click"
        >
        <HeaderGroup :groups="groups"></HeaderGroup>
        <el-button slot="reference" class="groupbtn">
          {{group?group.groupName:null}}
          <i class="el-icon-arrow-down"></i>
        </el-button>
      </el-popover>
    </div>
    <div class="rightcont">
      <el-popover
        width="300"
        trigger="hover"
        placement="bottom-start"
        @show="goKefu"
        >
        <!-- <div class="kefu"><span class="kefuicon emailkefu"></span>didichuxingquan@didichuxing.com</div> -->
        <div class="kefu kefuisLast"><span class="kefuicon phonekefu"></span>24小时客服：<span class="bold"> 400-000-0777</span></div>
        <span  slot="reference" class="vip">VIP客服<i class="el-icon-arrow-down"></i></span>

      </el-popover>

      <a class="help" href="https://opendocs.xiaojukeji.com/chuxingquan" target="_blank" @click="goHelp">帮助中心</a>
      <el-popover
        placement="bottom-end"
        width="500"
        trigger="manual"
        popper-class="taskPop"
        :offset ='200'
        v-model="showTask">
          <section
            class="taskWrap"
          >
            <h2>任务<span @click="showTask = !showTask">收起</span></h2>
            <ul class="taskUl" v-if='taskList.length > 0'>
              <TaskItem
                v-for="task in taskList"
                v-bind:key="task.id"
                v-bind="task"
                v-bind:groupId = 'selfGroup ? selfGroup.groupId : ""'
              ></TaskItem>
            </ul>
            <p v-else class="noTask">暂无任务</p>
          </section>
        <span 
          class="taskHook" 
          @click="openTaskPop"
          slot="reference">任务</span>
      </el-popover>
      <span class="headimg"></span>
      <el-popover
        width="70"
        trigger="hover"
        placement="bottom-start"
        >
        <div class="quit" @click="quitSys">退出登录</div>
        <span class="name bold" slot="reference">{{info.userName}}<i class="el-icon-arrow-down"></i></span>

      </el-popover>

      <!-- <span class="name">{{info.userName}}</span> -->
    </div>
    <el-dialog
      v-if="showModal"
      :title="agreementData ? agreementData.name :'' "
      :visible.sync="showModal"
      width="40%"
      :show-close="control"
      :close-on-press-escape="control"
      :close-on-click-modal="control"
      center>
      <div class="protocol">
        <div class="title">{{ agreementData ? agreementData.content : '' }}</div>
        <a target="_blank" :href="agreementData ?agreementData.link_url:''">{{agreementData ?agreementData.link_text:''}}</a>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="createBtnLoading" @click="goCreateGroup">{{agreementData ? agreementData.agree_btn_text :''}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="isShowAttentionDia"
      title="滴滴出行券平台服务主体变更通知"
      :visible.sync="isShowAttentionDia"
      width="30%"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center>
      <div class="protocol">
        <div class="hasLeft ">尊敬的用户，您好！</div>
        <div class="hasLeft">滴滴出行券平台服务主体现已由“滴滴出行科技有限公司”变更为“北京桔财动力科技有限公司”。变更前的充值、开票、余额，您可至原先工作台进行查看并使用，或进行退款操作，原工作台的充值余额，继续开具“滴滴出行”发票。即日起充值或开票，均由“桔财动力”提供服务，您可至对应的“桔财动力”后缀的后台进行查看并使用。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="height: 30px; line-height:30px"   ><el-checkbox style="height: 30px; line-height:30px"   v-model="noAttentionAgainChecked">不再提示</el-checkbox></div>
        <el-button type="primary" @click="closeAttentionDia">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import HeaderGroup from './HeaderGroup'
import { Message } from 'element-ui'
import TaskItem from './TaskItem'
import { getCookie, clearCookie ,setCookie} from '../plugins/helper'
import {customConfig} from '../service/config.js'
export default {
  name: 'TopHeader',
  data () {
    return {
      info: {},
      group: {},
      groups: [],
      showModal: false,
      control: false,
      showTask: false,
      TaskTimer:null,
      noAttentionAgainChecked:false,
      isOldGroup:false,
      noAttentionAgain:false,
      attentionDiaStatus:true
    }
  },
  components: {HeaderGroup,TaskItem},
  created () {
    // console.log('ssss')
    // if(!Object.keys(this.$store.selfGroup).length){
    this.getUserInfo()
    this.getAgreement()
    // }
  },
  computed: {
    ...mapState('header', ['userInfo', 'selfGroup','taskList','cancelSuccess','agreementData','cancelFail','createBtnLoading']),
    isShowAttentionDia:function(){
      return this.isOldGroup && this.attentionDiaStatus && !this.noAttentionAgain
    }
  },
  methods: {
    ...mapActions('header', ['getUserInfo','queryTaskList',  'createGroup','getAgreement', 'signOff','getDiscount']),
    ...mapMutations('header', ['SET_GROUP']),
    goCreateGroup () {
      this.createGroup()
    },
    goHelp () {
      this.omgTrack('es_chuxingquan_xieyi_help_sw', '出行券模块打开帮助中心页面')
    },
    goKefu () {
      this.omgTrack('es_chuxingquan_xieyi_vip_customservice_sw', '出行券模块打开vip客服页面')
    },
    quitSys () { // 退出登录
      // clearCookie('auth_token')
      let q = {
        'appid': 90000,
        'country_calling_code': '+86',
        'api_version': '1.0.0',
        'ticket': getCookie('ticket')
      }
      this.signOff({
        'q': JSON.stringify(q),
        'callback': function () {
          window.location.href = '//es.xiaojukeji.com/Auth/logout?redirect_uri=' + customConfig.redirectUri
        }})
      // window.location.href = 'https://es.xiaojukeji.com/Auth/login?redirect_uri=' + customConfig.redirectUri
      // let keys1 = document.cookie.match(/[^ =;]+(?=\=)/g)
      // console.log(keys1 + '8888')
    },
    openTaskPop(){
      this.showTask = !this.showTask
      this.queryTaskList()
    },
    closeAttentionDia(){
      console.log(this.noAttentionAgainChecked)
      this.attentionDiaStatus = false
      this.noAttentionAgain = this.noAttentionAgainChecked
      
      setCookie('no_attention_again', Number(this.noAttentionAgainChecked), 365)
    }
  },
  mounted () {
    // 埋点
    setTimeout(() => {
      const openSource = this.$route.query.source
      if (openSource === 'es') { // 来源es后台
        this.omgTrack('es_chuxingquan_sw', '打开出行券模块', {source: 'es后台'})
      } else if (openSource === 'landingpage') { // 落地页
        this.omgTrack('es_chuxingquan_sw', '打开出行券模块', {source: '落地页'})
      } else if (!openSource) { // 直接打开
        this.omgTrack('es_chuxingquan_sw', '打开出行券模块', {source: '直达'})
      } else { // 其他
        this.omgTrack('es_chuxingquan_sw', '打开出行券模块', {source: '其他'})
      }
    }, 2000)
    let noAttentionAgainCookie = getCookie('no_attention_again');
    if(noAttentionAgainCookie == 1 ){
      this.noAttentionAgain = true
    }
  },
  watch: {
    userInfo: function (value) {
      // console.log(value)
      if (value && Object.keys(value).length > 0) {
        this.info = value
        // console.log(Array.isArray(value.groups))
        if (Array.isArray(value.groups)) {
          if (value.groups.length > 0) {
            let groupCookie = getCookie('cur_group')
            let hasGroup = value.groups.filter((item) => {
              return item.groupId === groupCookie
            })
            let computedGroup = hasGroup.length > 0 ? hasGroup[0] : value.groups[0]
            this.group = computedGroup
            this.groups = value.groups
            this.SET_GROUP(computedGroup)
            this.$emit('setGlobleGroup', true)
            // 判断是协作者跳转路由

            if (computedGroup.role === 1) {
              this.$router.push({
                path: '/sendcoupon/sendbyphone'
              }).catch(err => {})
            }
            //判断是否是旧工作台形式
            console.log('computedGroup',computedGroup)
            if(computedGroup.version === 0){
              this.isOldGroup  = true
            }else{
              this.isOldGroup  = false
            }
          } else { // 没有工作台默认创建
            this.showModal = true
            this.$emit('setGlobleGroup', false)
            // 埋点
            this.omgTrack('es_chuxingquan_xieyi_sw', '出行券模块打开协议')
          }
        }
      }
    },
    selfGroup: function (value) {
      if (value && value.groupId !== this.group.groupId && this.groups.length > 0) { // 切换工作台
        for (let i in this.groups) {
          if (this.groups[i].groupId === value.groupId) {
            this.group = this.groups[i]
          }
        }
        this.$refs.head.click()
      } else if (!this.groups.length) { // 同意出行券协议
        this.showModal = false
        this.group = value
        let arr = []
        arr.push(value)
        this.groups = arr
        this.$emit('setGlobleGroup', true)
        // 埋点
        this.omgTrack('es_chuxingquan_xieyi_agree_ck', '出行券模块同意协议')
      }
    },
    cancelSuccess:function(value){
      if(value){
        Message.success('取消成功')
        this.$store.commit('header/setLoadingFalse', 'cancelSuccess')
        clearTimeout(this.TaskTimer);
        this.queryTaskList()
      }
    },
    showTask:function(value){
      if(!value){
        clearTimeout(this.TaskTimer)
      }
    },
    cancelFail:function(value){
      if(value){
        Message.error('取消失败')
        this.$store.commit('header/setLoadingFalse', 'cancelFail')
      }
    },
    taskList:function(value,oldVal){
      if(value.length ===0){
        clearTimeout(this.TaskTimer)
      }else{
        let loadingArr = value.filter(task=>{
          return task.status === 0
        })
        if(loadingArr.length > 0){
          this.TaskTimer  = setTimeout(()=>{
            this.queryTaskList()
          },5000)
        }else{
          clearTimeout(this.TaskTimer)
        }
      }
      // console.log('watcherTASKLIST',value)
    },
    group:function(value){
      if(value){
        this.getDiscount()  
      }
    }
  }
}
</script>
<style  scoped lang="stylus">
  .head{
    height: 70px;
    position: relative;
    line-height: 70px;
    .leftcont{
      display: inline-block;
      margin-left: 30px;
      .name{
        font-size: 20px;
        color: #333;
      }
      .workbar{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
        margin-right: 5px;
        .el-button{
          border:none;
        }
        .el-button:hover{
          background: #fff;
          color: #666;
        }
      }
      .groupbtn{
        padding-top: 0px;
        padding-bottom: 0;
        height: 30px;
        display: inline-block;
        color:#666;
      }
    }
    .rightcont{
      display: inline-block;
      position: absolute;
      right: 30px;
      font-size:14px;
      font-weight:400;
      color:#333;
      .help{
        margin-left: 40px;
        margin-right: 50px;
        text-decoration: none;
        color: #333;
      }
      .bold{
        font-weight: bold;
      }
      .headimg{
        background: url('../images/nav_img_touxiang.png');
        background-size: 100% auto;
        display:inline-block;
        width:32px;
        height:32px;
        position: relative;
        top: 10px;
        left: -10px;
      }
      .el-icon-arrow-down{
        margin-left:3px;
      }
    }
  }
  .el-popover{
    position: relative;
    top: -20px
  }
  .protocol{
    max-height:300px;
    overflow:auto;
    margin-top: -30px;
    line-height: 30px;
    h2{
      text-align:center;
    }
    .bold{
      font-weight: bold;
    }
    .title{
      text-indent: 2em
    }
    a{
      color: #409EFF;
    }
  }
  .kefu{
    height: 65px;
    border-bottom: solid 1px #e5e5e5;
    font-size: 14px;
    margin-left:16px;
    margin-right:16px;
    color:#333;
    line-height:65px;
    .kefuicon{
      width: 28px;
      height: 28px;
      display: inline-block;
      background-repeat: no-repeat;
      position: relative;
      top:10px;
      margin-right:10px;
    }
    .emailkefu{
      background: url('../images/ic_home_email.png');
      background-size: 100% auto;
    }
    .phonekefu{
       background: url('../images/ic_home_phone.png');
       background-size: 100% auto;
    }
    .time{
      display: block;
      color:#6666
      position: relative;
      left: 38px;
      top: 5px;
    }
    .bold{
      font-weight :bold
    }
  }
  .kefuisLast
    border-bottom:none
    line-height :20px
  .quit
    margin-top: 8px;
    margin-bottom: 8px;
    text-align: center;
    cursor: pointer
  .quit:hover{
    color: #3467fe
  }
.taskHook{
  margin-right 50px;
  cursor pointer
}
.taskPop{
  .taskWrap{
    h2{
      font-size: 14px;
      font-weight: bold;
      border-bottom: 1px solid #ccc;
      padding-bottom: 5px;
      padding-left: 5px;
      span{
        cursor: pointer
        font-weight:400;
        float:right 
        color #9b9b9b
      }
    }
    .taskUl{
      max-height 252px;
      overflow auto
    }
    .noTask{
      line-height 150px;
      text-align center
    }
  }
}
</style>
